<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12 col-md-12 col-sm-12">
        <div class="card card-top-line">
          <div class="header">
            <h2>Email and Messages</h2>
          </div>
          <div class="body pt-0">
            <div class="chart-top-action d-lg-flex justify-content-end py-3">
              <div
                class="d-md-flex justify-content-between mt-lg-0 mt-md-3 mt-0"
              >
                <div
                  class="payment-dropdown d-flex flex-row-reverse ml-lg-3 mt-3 mt-sm-0"
                >
                  <router-link
                    class="btn btn-primary btn-mw btn-lg"
                    to="/send-promotional-email/single-remitter/send"
                  >
                    Add New
                    <i class="fa fa-plus-square"></i>
                  </router-link>
                </div>
              </div>
            </div>
            <!-- Table Pagination -->
            <div
              class="py-1 align-items-center justify-content-end table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <b-table
              ref="partnertable"
              responsive
              hover
              table-class="js-basic-example table-custom mb-0 border"
              head-variant="light"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              striped
            >
              <template #head()="{ label, field: { key } }">
                {{ label }}
                <!-- Custom icons -->
                <template>
                  <i v-if="sortBy !== key" class=""></i>
                  <i
                    v-else-if="sortDesc"
                    class="fa fa-long-arrow-down ml-1"
                  ></i>
                  <i v-else class="fa fa-long-arrow-up ml-1"></i>
                </template>
              </template>
              <template #cell(sent_to_users)="data">
                <div>
                  <span class="font-weight-bold">Remitter Group:</span>
                  {{ data.value.remitterGroup }}
                </div>
                <div>
                  <span class="font-weight-bold">Customer Emails:</span>
                  {{ data.value.customer_emails.toString() }}
                </div>
              </template>
            </b-table>
            <!-- Table Pagination -->
            <div
              class="py-3 align-items-center justify-content-between table-pagination"
              :class="totalRows > 0 ? ' d-flex' : 'd-none'"
            >
              <div class="per-page">
                <b-form-group
                  label="Per page"
                  label-for="per-page-select"
                  class="mb-0"
                >
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
// import { GET_PARTNER_LIST } from "../../../store/actions.type.js";
import { mapState, mapGetters } from "vuex";
export default {
  name: "SingleRemitterEmailComponent",
  components: {
    BreadCrumb,
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      items: [
        {
          email_content: "-",
          sms_content: "Image notification",
          sent_to_users: {
            remitterGroup: "Basic",
            customer_emails: ["test@yopmail.com", "test1@yopmail.com"],
          },
          date: "2024-06-06 12:42:25",
        },
        {
          email_content: "-",
          sms_content: "it's content of push notification",
          sent_to_users: {
            remitterGroup: "Silver",
            customer_emails: ["test@yopmail.com"],
          },
          date: "2023-05-26 02:09:19",
        },
        {
          email_content: "test email content",
          sms_content: "-",
          sent_to_users: {
            remitterGroup: "Bronze",
            customer_emails: [
              "test@yopmail.com",
              "test1@yopmail.com",
              "test2@yopmail.com",
              "test3@yopmail.com",
              "test2@yopmail.com",
              "test3@yopmail.com",
            ],
          },
          date: "2018-09-24 15:12:22",
        },
      ],

      fields: [
        {
          key: "sms_content",
          label: "SMS Content",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "25%" },
        },
        {
          key: "email_content",
          label: "Email Content",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "25%" },
        },
        {
          key: "sent_to_users",
          label: "Sent to Users",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "25%" },
        },
        {
          key: "date",
          label: "Sent date",
          sortable: true,
          thClass: "th_sortfix",
          thStyle: { width: "25%" },
        },
      ],

      totalRows: 0,
      currentPage: 1,
      currentPageJump: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: 100 }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filterValue: "",
      condition: "",
    };
  },
  methods: {
    getSentNotificationList() {
      // this.$store.dispatch(GET_PARTNER_LIST).then((response) => {
      //     console.log(response)
      // });
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getSentNotificationList();
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
